'use strict';

module.exports = {
  margin: 'margin',
  marginRate: 'marginRate',
  price: 'price',
  doNothing: null,
  manuallySet: 'manuallySet',
};
